import React, { useMemo } from 'react';
import { CheckCircle } from '@mui/icons-material';
import Globe from './Globe';

// List of tickbox items for the Hero component
const TICKBOX_ITEMS = [
  'Pay gap analysis for EU reporting',
  'Country-specific compliance workflows',
  'GDPR-compliant handling of compensation data',
];

const Hero = () => {
  // Memoized tickbox items component
  const TickboxItems = useMemo(
    () => (
      <div className="flex flex-col gap-4 mt-10 max-sm:-ml-3 ml-0">
        {TICKBOX_ITEMS.map((item, idx) => (
          <div key={idx} className="flex items-center gap-2 text-base text-gray-800 w-full">
            <CheckCircle sx={{ fontSize: 20, color: '#47e5c0' }} />
            <span>{item}</span>
          </div>
        ))}
      </div>
    ),
    [],
  );

  return (
    <div className="content max-sm:pt-[18vh] pt-[10vh] max-sm:bg-white pb-5 sm:pb-5">
      <div className="flex flex-col sm:flex-row gap-8">
        <div className="h-fit sm:w-[50%]">
          <div className="relative inline-flex rounded-full mb-1 overflow-hidden p-[2px] max-w-full">
            <div className="absolute left-0 top-1/2 -translate-y-1/2 w-full h-[400px] rounded-full card-wrapper hero-chip-spin"></div>
            <a
              href="https://store.novoinsights.com/products/category-snapshot-pay-equity-and-transparency?srsltid=AfmBOoqoxEy4BTyYbq_qk5wpLMNwLmrAiYcMXIcdr4pk6Z-R8UltWqzk"
              target="_blank"
              rel="noopener noreferrer"
              className="relative z-10 rounded-full border border-indigo-100 px-2.5 py-0.5 text-[11px] leading-4 font-medium text-gray-600 shadow-sm hover:bg-gray-100 duration-200 bg-white w-fit max-w-full flex flex-row items-center gap-1 whitespace-nowrap sm:px-3 sm:py-1 sm:text-[13px] sm:leading-5"
            >
              <span className="sm:hidden">Pay Transparency Leader</span>
              <span className="hidden sm:inline">Recognized Leader in Pay Transparency Technology</span>
              <span className="text-indigo-600 font-normal">• Get the Report</span>
            </a>
          </div>

          <div className="flex flex-col gap-4 lg:gap-6 mt-2 sm:mt-6">
            <h1 className="fade-in delay-1 max-sm:text-5xl text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tighter">
              <span className="-ml-0.5">EU Pay Transparency Directive compliance for</span>
              <br />
              <span>multinational employers</span>
            </h1>
          </div>
          <div className="mt-8 text-gray-700 text-lg max-sm:w-full max-lg:w-[50%]">
            Sophare helps employers prepare pay data, analyze pay gaps, and produce defensible reporting for EU pay
            transparency compliance before June 7, 2026.
            <span className="hidden md:inline">
              <br />
            </span>
          </div>

          {TickboxItems}
          <div className="flex flex-row items-center gap-4 rounded-sm mt-10 max-sm:-ml-3 -ml-2">
            <a
              href={'/contact'}
              className="whitespace-nowrap rounded-full text-left  outline-none ring-0 transition-all focus:border-none focus:outline-none font-medium flex items-center gap-3 px-5 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 active:scale-95 duration-200 bg-indigo-600 text-white"
              // target="_blank"
              rel="noopener noreferrer"
            >
              Book a demo
            </a>
            <a
              className="font-medium flex flex-row items-center gap-1 hoverable-black group"
              href={process.env.REACT_APP_DASH_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>Log in</span>
              <svg
                stroke="currentColor"
                fill="currentColor"
                strokeWidth="0"
                viewBox="0 0 512 512"
                className="inline-block transition-transform duration-200 ease-out group-hover:translate-x-1"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="48"
                  d="m268 112 144 144-144 144m124-144H100"
                ></path>
              </svg>
            </a>
          </div>
        </div>
        <div className="-z-[100] relative w-full sm:w-[50%] h-[500px] sm:mt-12 hidden sm:block">
          <Globe />
        </div>
      </div>
    </div>
  );
};

export default Hero;
